import React, { useEffect } from "react";
import FotterMain from "../BaseComponents/FotterMain";
import Header from "../BaseComponents/Header";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { baseURL } from "../../networkCalls";
import SEO from "../BaseComponents/SEO";
import useSeo from "../BaseComponents/SEO";

const AboutUs = () => {
  const toTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    toTop();
  }, []);
  const seo = useSeo();
  const url = window.location.href;
  // console.log({url});
  const testurl =
  `${process.env.REACT_APP_PRO_MODE.replace(/\/$/, "")}${window.location.pathname}`;

  return (
    <>
        <SEO
       url={testurl}
      />
      <Header />
      <div className="innerpagebg pb-5">
        <div className="about__image">
          <div className="about__image-bg">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-12 mt-5">
                  <div className="bg-white mt-5 p-5">
                    <h1 className="h1_heading d-block m-0 fw-bold text-uppercase mb-3 mt-2 text-center">
                      <span className="txtred">About</span>{" "}
                      <span className="txtdgray">Us</span>
                    </h1>
                    <div className="f18 text-center">
                      India's No. 1 Power Products company, Honda India Power
                      Products Limited (HIPP), is a subsidiary of Honda Motor
                      Co. Japan and was incorporated on 19th Sept 1985.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="bg-white shadow-sm">
                <br />
                <br />
              </div>
            </div>
            <div className="col-md-8">
              <div className="row mt-5">
                <div className="col-12 col-lg-4 d-flex mb-3">
                  <div>
                    <img
                      src={require("./../../assets/icons/hand-shake.png")}
                      alt=""
                      className=""
                      style={{ width: "40px" }}
                    />
                  </div>
                  <div className="ms-3">
                    <span className="txtred fw-bold f18">STRENGTH</span>
                    <br />
                    500+ DEALERS
                  </div>
                </div>
                <div className="col-12 col-lg-4 d-flex mb-3">
                  <div>
                    <img
                      src={require("./../../assets/icons/customer.png")}
                      alt=""
                      className=""
                      style={{ width: "40px" }}
                    />
                  </div>
                  <div className="ms-3">
                    <span className="txtred fw-bold f18">CUSTOMERS</span>
                    <br /> 6 MILLION+
                  </div>
                </div>
                <div className="col-12 col-lg-4 d-flex mb-3">
                  <div>
                    <img
                      src={require("./../../assets/icons/coronavirus.png")}
                      alt=""
                      className=""
                      style={{ width: "40px" }}
                    />
                  </div>
                  <div className="ms-3">
                    <span className="txtred fw-bold f18">EXPORT</span>
                    <br /> 30 COUNTRIES
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row mt-4">
            <div className="col-12 f14" style={{ lineHeight: "24px" }}>
              <p>
                Ever since, it has been the undisputed leader in the power
                products industry, manufacturing and marketing a range of
                Portable Generators, Water Pumps, Tillers and General Purpose
                Engine at its state-of-art manufacturing facility at Greater
                Noida. It is also engaged in the marketing of Lawn Mower, Brush
                Cutter and Outboard Motors.
              </p>
              <p>
                What Started in 1985 as a dream to serve our customers with
                products that truly help him do their work more efficiently has
                unfolded into a remarkable journey of achieving many milestones.
                HIPP has been the preferred choice of the customers worldwide
                and its existence is the result of the creation of the joy of
                buying, selling & empowering the dreams of over 5 million users
                which makes HIPP the undeniable leader in the power production
                industry.
              </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6">
              <div className="">
                <div className="f14" style={{ lineHeight: "24px" }}>
                  <h4 className="d-block m-0 fw-bold text-uppercase mb-0 mt-2 text-start f20">
                    {/* <span className='txtred'>CORE</span> <span className='txtdgray'>PHILOSOPHY</span> */}
                    <span className="txtred">HONDA</span>{" "}
                    <span className="txtdgray">PHILOSOPHY</span>
                  </h4>
                  <p>
                  {/* "The power of dreams" */}
                  </p>
                  {/* Driven to the core by its philosophy of "The power of dreams", HIPP with the strength of 17 Area Offices across India and over 500+ dealers have been continuously bringing joy and satisfaction through its range of power products that suit the requirements of a variety of customers segments in agriculture, domestic and commercial. This gives the customers the choice to demand more from the world leader "Honda". */}
                  The Honda Philosophy consists of Fundamental Beliefs
                  (including "Respect for the Individual" and "The Three Joys"),
                  the Company Principle, and Management Policies. This
                  philosophy is not only shared by all associates, but also
                  forms the basis for all company activities and sets the
                  standard for the conduct and decision-making of all associates
                  throughout the Honda Group. Driven by its dreams and
                  reflecting its values, Honda will continue taking on
                  challenges to share joys and excitement with customers and
                  communities around the world to strive to become a company
                  society wants to exist.
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
            <img
                      alt=""
                     
                      className="honda_philosophy_image mb-4 mt-3"
                      // style={{ maxWidth: "75px" }}
                      src={`${baseURL}images/new-philosophy.png`}
                    />
              {/* <div className="row">
                <div className="col-12 col-md-6">
                  <div className="card p-4 text-center mb-4 shadow-sm border-0">
                    <LazyLoadImage
                      alt=""
                      effect="blur"
                      className="img-fluid mb-4 mt-3"
                      style={{ maxWidth: "75px" }}
                      src={`${baseURL}images/home-icon-4.png`}
                    />
                    <div className="txtdgray f16 f14sm fw-bold">
                      Environmental friendly
                    </div>
                    <div className="txtlgeay">4-stroke technology</div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="card p-4 text-center mb-4 shadow-sm border-0">
                    <LazyLoadImage
                      alt=""
                      effect="blur"
                      className="img-fluid mb-4 mt-3"
                      style={{ maxWidth: "75px" }}
                      src={`${baseURL}images/home-icon-5.png`}
                    />
                    <div className="txtdgray f16 f14sm fw-bold">
                      2500 company
                    </div>
                    <div className="txtlgeay">trained mechanics</div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="card p-4 text-center mb-4 shadow-sm border-0">
                    <LazyLoadImage
                      alt=""
                      effect="blur"
                      className="img-fluid mb-4 mt-3"
                      style={{ maxWidth: "75px" }}
                      src={`${baseURL}images/home-icon-6.png`}
                    />
                    <div className="txtdgray f16 f14sm fw-bold">
                      Mobile service
                    </div>
                    <div className="txtlgeay">vans for prompt service</div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="card p-4 text-center mb-4 shadow-sm border-0">
                    <LazyLoadImage
                      alt=""
                      effect="blur"
                      className="img-fluid mb-4 mt-3"
                      style={{ maxWidth: "75px" }}
                      src={`${baseURL}images/home-icon-3.png`}
                    />
                    <div className="txtdgray f16 f14sm fw-bold">Automated</div>
                    <div className="txtlgeay">service workshops</div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="bglblue">
          <div className="container pt-5 pb-5">
            <div className="row">
              <div className="col-12 col-lg-12">
                <h4 className="d-block mb-3 fw-bold text-uppercase mb-0 mt-2 text-start f20">
                  <span className="txtred">TECHNOLOGY</span>{" "}
                  <span className="txtdgray">& CERTIFICATION</span>
                </h4>
              </div>
              <div className="col-12 col-lg-8">
                <p className="f14" style={{ lineHeight: "24px" }}>
                  HIPP benefits from the rich experience of Honda Motor Co.
                  Japan the second largest engine manufacturer in the world,
                  because of their strong emphasis on R&D and in-house technical
                  innovation.
                </p>
                <p className="f14" style={{ lineHeight: "24px" }}>
                  The Ultra Silent, Self-start range of India's first "Pure Sine
                  Wave EU series Generator" and the highly fuel-efficient range
                  of OHV Engines are some of the products which exemplify
                  Honda's pursuit of technological excellence. The product range
                  of Generators conforms to the most stringent phase IV Noise &
                  Emission norms as laid down by Central Pollution Control Board
                  (CPCB), Government of India.
                </p>
                <p className="f14" style={{ lineHeight: "24px" }}>
                  Every product manufactured is the result of persistence in
                  quality, giving it the cutting edge for that extra
                  reliability. It was in recognition of this that HIPP became
                  the first power products manufacturing company in India to
                  have been awarded the ISO 9001:2000 Certification for its
                  Quality Assurance Systems & ISO 14001 for its Environment
                  Management systems.
                </p>
                <div className="d-flex">
                  <div className="me-3">
                    <div className="card p-4 text-center shadow-sm border-0">
                      <img
                        src={`${baseURL}images/ISO-certified.png`}
                        className="ms-2 ms-2"
                      />
                    </div>
                  </div>
                  <div className="">
                    <div className="card p-4 text-center shadow-sm border-0">
                      <img
                        src={`${baseURL}images/ISO-14001.png`}
                        className="ms-2 ms-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 text-end">
                {/* <img
                  alt=""
                  width={100}
                 
                  className="img-fluid mb-4 mt-3"
                  src={`${baseURL}images/Aboutus.JPG`}
                  // src={'../../assets/img/Aboutus.JPG'}
                /> */}
                <LazyLoadImage
                  alt=""
                  effect="blur"
                  className="aboutUsprotrait mb-4 mt-3"
                  src={`${baseURL}images/Aboutus.JPG`}
                  // src={'../../assets/img/Aboutus.JPG'}
                />
              </div>

              {/* <div className='col-12 col-lg-6'>
                Image Here
              </div> */}
            </div>
          </div>
        </div>
        <div className="container pt-5 pb-5">
          <div className="row">
            <div className="col-12">
              <h4 className="d-block mb-3 fw-bold text-uppercase mb-0 mt-2  f20">
                <span className="txtred">WHY</span>{" "}
                <span className="txtdgray">US</span>
              </h4>
              <p className="f14" style={{ lineHeight: "24px" }}>
                Honda is committed to bringing joy in the lives of customers
                through innovative, reliable and technologically advanced power
                products that make a significant contribution to the Indian
                society by increasing the quality of their living standards and
                becoming a part of their daily lives.
              </p>
              <p className="f14" style={{ lineHeight: "24px" }}>
                While maintaining its leadership in the domestic generator
                market and export to over 30 countries, HIPP is making active
                efforts in developing new applications for its General-Purpose
                Engines (GPE). HIPP enjoys the majority of market share of
                Generators and Water pumps. The business of GPE and Water Pump
                sets is expected to contribute significantly to the company's
                future growth plans.
              </p>
              <p className="f14" style={{ lineHeight: "24px" }}>
                What started off as an "impossible dream" has today blossomed
                into a really touching people's daily lives in various ways?
                That's the power of dreams...and that dream lives on.
              </p>
            </div>
          </div>
        </div>
      </div>
      <FotterMain />
    </>
  );
};

export default React.memo(AboutUs);
